import { createIcon } from './create-icon';

export const ArrowRightIcon = createIcon(
  'ArrowRightIcon',
  <>
    <path d="M5 12h14" />
    <path d="M12 5l7 7-7 7" />
  </>,
);
